export default __webpack_public_path__ + "static/media/attack.6f0303b3.jpg";